import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/api";
import { queue } from "@/components/Toast";
import { organizationErrorMessage } from "./useOrganization";

type ChangePasswordInput = {
  currentPassword: string;
  newPassword: string;
};

/**
 * Not optimistic: nothing cached changes, and the form has to keep its values
 * when the current password is wrong. The backend answers that with a 400, not
 * a 401, so the axios interceptor doesn't mistake it for an expired session.
 * Every other session of the user is signed out; this one stays.
 */
export function useChangePassword() {
  return useMutation({
    mutationFn: async (input: ChangePasswordInput) => {
      await axiosInstance.post("/auth/change-password", input);
    },
    onSuccess: () => {
      queue.add({
        title: "Password changed",
        description: "Your other devices will be signed out.",
        variant: "success",
      });
    },
    onError: (err) => {
      queue.add({
        title: "Could not change password",
        description: organizationErrorMessage(err, "Please try again."),
        variant: "error",
      });
    },
  });
}
